const { get } = require('@ebay/str-ui-utils/retriever');
const { trackEvent } = require('@ebay/str-ui-utils/tracking-util');

module.exports = {
    onInput(input) {
        // TODO: handle error case of no URL received from API
        this.url = get(input, 'shareUrlAction.URL', '');
        this.windowTitle = get(input, 'shareUrlAction.windowName', '');
        this.enableCheckmark = get(input, 'enableSharedCheckmark', false);
        this.state = {
            showCheckmark: false
        };
    },

    // email click is handled differently since
    // it uses mailto and we dont want to open new browser window but launch email client.
    // did not use href for mailto link because ebayui-button changes to 'a' tag on adding href
    // and spacebar does not work on href.
    // so we create hidden a tag with href and trigger click on it to lauch email.
    triggerEmail() {
        const anchorEl = document.createElement('a');
        anchorEl.style.display = 'none';
        anchorEl.href = this.url;
        anchorEl.click();
        anchorEl.remove();
    },

    handleClick(channelType, event) {
        trackEvent(event);
        if (this.enableCheckmark) {
            // show checkmark feature
            this.setState('showCheckmark', true);
        } else {
            // close the dialog, checkmark not shown
            this.emit('social-media-click');
        }
        if (channelType === 'email') {
            this.triggerEmail();
            return;
        }
        this.openRequestedSocialWindow();
    },

    openRequestedSocialWindow() {
        // TODO:  window size specific to viewport
        const windowFeatures = 'resizable=yes,scrollbars=yes,status=yes,left=200,top=200,width=800,height=400';
        this.windowObjectReference = window.open(this.url, this.windowTitle, windowFeatures);
    }
};
